import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitStrings',
  standalone: true
})
export class SplitStringsPipe implements PipeTransform {
  transform(value: string[]): { title: string, subtitle: string, content?: string }[] {
    return value?.map(item => {
      const parts = item?.split('|');
      return {
        title: parts[0],
        subtitle: parts[1],
        content: parts[2] || null
      };
    });
  }

}